/**
 * The card zoom side panel. UI_UX section 7.
 *
 * Pointing at any card opens the zoom frame beside the board, with keyword
 * chips that link into HELP. On mobile the same panel docks to the bottom, so
 * a long press or a tap reaches the identical content: nothing here requires
 * hover to be discoverable.
 */

import type { GameState } from '@/engine';
import { CardFrame, viewFromObject } from '@/ui/cards';
import { UiIcon } from '@/ui/icons/UiIcon';
import { Button } from '@/ui/system';
import styles from './Battlefield.module.css';

export function ZoomPanel({
  state,
  instanceId,
  onClose,
}: {
  state: GameState;
  instanceId: string | null;
  onClose: () => void;
}) {
  if (!instanceId) return null;
  const view = viewFromObject(state, instanceId);
  if (!view) return null;

  return (
    <div className={styles.zoomPanel} data-testid="zoom-panel">
      <CardFrame card={view} size="zoom" flat />
      <Button variant="ghost" size="small" icon={<UiIcon name="close" size={13} />} onClick={onClose}>
        Close
      </Button>
    </div>
  );
}
